export default __webpack_public_path__ + "static/media/user-icon.be63691c.svg";